/* unplugin-vue-components disabled */import script from "./global.vue?vue&type=script&lang=js"
export * from "./global.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__